import { h, Host } from "@stencil/core";
export class Quote {
    constructor() {
        this.quote = "";
        this.source = "";
        this.image = "";
    }
    baseClass = "ux-quote";
    render() {
        return (h(Host, { key: 'c57f4441a61301b3a724e9903cdc158e673c1607', class: this.baseClass }, h("div", { key: 'e57b253f92d3d152b00377ffc40d978683a4d8a3', class: `${this.baseClass}__container` }, this.image && h("img", { key: '8792c253f235d66aa08b5268c26b422b1c969299', src: this.image, class: `${this.baseClass}__container-image` }), h("div", { key: 'f0e1afc8e474dabda1620fd33deda940523bb5bc', class: `${this.baseClass}__container-text ux-u-text-bold` }, this.quote)), h("div", { key: '58c8cf7588999f3ec69a2bcff3c2edead5e040dc', class: {
                [`${this.baseClass}__source-container`]: true,
                [`ux-col-11`]: true,
                [`${this.baseClass}__source-container--image`]: this.image.length > 0
            } }, this.source)));
    }
    static get is() { return "ux-quote"; }
    static get originalStyleUrls() {
        return {
            "$": ["quote.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["quote.css"]
        };
    }
    static get properties() {
        return {
            "quote": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "default",
                            "text": "\"\""
                        }],
                    "text": "The quote text to display."
                },
                "attribute": "quote",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "source": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "default",
                            "text": "\"\""
                        }],
                    "text": "The source of the quote to display."
                },
                "attribute": "source",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "image": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "default",
                            "text": "\"\""
                        }],
                    "text": "The image associated with the quote to display."
                },
                "attribute": "image",
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
}
//# sourceMappingURL=quote.js.map
